module.exports = __webpack_public_path__ + "static/media/aqua4.c513b030.jpeg";